module.exports = __webpack_public_path__ + "img/area.0520d59e.png";